import React from 'react';
import { Stack, Heading, Text, Flex } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import HeroBg from './data/assets/Hero/Hero-temp.png'

function Hero({ text }) {
    return(
        <Flex  w='100%' minH='100vh' bgImage={HeroBg}  backgroundSize={['cover']} alignItems='center' justifyContent='center '>            
          <Stack direction='column' alignItems='center' mb='5%'>
            <Heading fontSize={['7xl','100px']} textAlign={'center'} color='white' textShadow='0px 4px 8px #414647' fontWeight='800'>Pedro Serrano</Heading>
            <Stack direction='row'>
              <SubtitleText subtitleText={text.subtitulo[1]} sectionLink={'/photography'} />
              <Text fontSize='2xl' color='white' fontWeight='300'>  -  </Text>
              <SubtitleText subtitleText={text.subtitulo[0]} sectionLink={'/video'} />
              <Text fontSize='2xl' color='white' fontWeight='300'>  -  </Text>
              <SubtitleText subtitleText={text.subtitulo[2]} sectionLink={'/design'} />
            </Stack>
          </Stack>
        </Flex>
    );


}

function SubtitleText({ subtitleText, sectionLink }) {
  return(
    <Link to={sectionLink}>
      <Text 
        fontSize='2xl'
        color='white'
        fontWeight='300'
        _hover={{ transform: 'scale(1.02);', color: '#e9e3b4' }}
        transitionDuration={'0.3s'}
        >
          {subtitleText}
      </Text>
    </Link>
  );
}

export default Hero;
